import React, { useState } from 'react';
import './style.scss';

const DEFAULT_BG_COLOR = 'rgba(0, 0, 0, 0.1)';
const DEFAULT_HOVER_BG_COLOR = 'rgba(0, 0, 0, 0.3)';
const DEFAULT_COLOR = '#000000';
const DEFAULT_WIDTH = '48px';
const DEFAULT_FONT_SIZE = '28px';
const DEFAULT_BORDER_RADIUS = '8px';

interface IProps {
  readonly name: string;
  readonly color?: string;
  readonly width?: string;
  readonly fontSize?: string;
  readonly borderRadius?: string;
  readonly isShowHover?: boolean;
}

export const GameAvatar = (props: IProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const width = props.width || DEFAULT_WIDTH;
  const fontSize = props.fontSize || DEFAULT_FONT_SIZE;
  const color = props.color || DEFAULT_COLOR;
  const borderRadius = props.borderRadius || DEFAULT_BORDER_RADIUS;

  const getBgColor = (isHover?: boolean) => {
    if (props.color) {
      const a = parseInt(props.color.slice(1, 3), 16);
      const g = parseInt(props.color.slice(3, 5), 16);
      const b = parseInt(props.color.slice(5, 7), 16);
      if (isHover) {
        return `rgba(${a}, ${g}, ${b}, 0.3)`;
      }
      return `rgba(${a}, ${g}, ${b}, 0.1)`;
    }
    if (isHover) {
      return DEFAULT_HOVER_BG_COLOR;
    }
    return DEFAULT_BG_COLOR;
  };

  const getText = () => {
    if (props.name.length === 0) {
      return '';
    }
    if (props.name.length === 1) {
      return props.name;
    }
    return props.name[0].toUpperCase();
  };

  const style: React.CSSProperties = {
    width,
    height: width,
    lineHeight: width,
    color,
    backgroundColor: getBgColor(),
    fontSize,
    borderRadius,
  };
  return (
    <div
      className="game-avatar"
      style={
        isHovered && props.isShowHover
          ? { ...style, backgroundColor: getBgColor(true) }
          : style
      }
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {getText()}
    </div>
  );
};
